/**
 * visibility-Landmark. Will be triggered if element enters the viewport.
 * @param {HTMLElement} element Element which posesses this landmark.
 * @param {object} data Landmark configuration data. Cannot be null.
 * @param {function} sendLandmark Function to send data to the landmark service. Cannot be null.
 */

export default function (element, data, sendLandmark) {
    // Only send landmark if element is visible and in viewport
    const observer = new IntersectionObserver(reactToElementEnteringViewport, {
        rootMargin: '0px',
        threshold: 0.0
    });
    observer.observe(element);
    function reactToElementEnteringViewport(intersectionObserverEntries) {
        intersectionObserverEntries.forEach( (entry) => {
            if (entry.intersectionRatio > 0) { //only react to elements becoming visible
                trackVisibility(element, data, sendLandmark);
            }
        });
    }
}

function extractFkIdFromFirstSwiperElement(element) {
    const swiperElements = element.querySelectorAll('a.swiper-slide');
    let fkId = -99; // -99 is error-fk
    if (swiperElements !== undefined
        && swiperElements.length > 0
        && swiperElements[0] !== undefined
        && swiperElements[0].hasAttribute('jsh-landmark__click')) {
        const lmAttribute = swiperElements[0].getAttribute('jsh-landmark__click');
        const fkIdWithBackslashes = lmAttribute.match(/\\-?\d+\\/); // wl_reco\-17\91111195 -> \-17\
        fkId = fkIdWithBackslashes.toString().replace(/\\/g, ""); // \-17\ -> -17
    }
    return fkId;
}

function trackVisibility(element, data, sendLandmark) {
    if (shouldBeTracked(element)) {
        markElementAsAlreadyTracked(element);
        data.landmark = data.landmark || 'action';
        if(data.hasOwnProperty("visible")) {
            data.visible = data.visible || '';
            if(data.visible.indexOf("{}") !== -1) {
                const fkId = extractFkIdFromFirstSwiperElement(element);
                data.visible = data.visible.replace("{}", fkId);
            }
        }
        sendLandmark(data);
    }
}

function shouldBeTracked(element) {
    return !element.hasAttribute(getTrackingMarkerName());
}

function markElementAsAlreadyTracked(element) {
    element.setAttribute(getTrackingMarkerName(), true);
}

function getTrackingMarkerName() {
    return 'data-visibility-tracked';
}